import React, { useState } from 'react';
import { ToggleComponent } from 'src/common/form/toggle/component';
import { ShareLinkFieldType } from '../link-config-form.factory';

interface Props {
  presentation: ShareLinkFieldType<boolean>;
  onFieldChange: <T>(payload: ShareLinkFieldType<T>) => void;
}

export const SharePresentations = ({ presentation, onFieldChange }: Props) => {
  const [presentationEnabled, setPresentationEnabled] = useState(presentation.value);
  const onConversationFieldToggleChanged = (value: boolean) => {
    setPresentationEnabled(value);
    onFieldChange({ field: presentation.field, value });
  };

  return (
    <div className='flex flex-col space-y-sm'>
      <ToggleComponent
        checked={presentationEnabled}
        onChange={onConversationFieldToggleChanged}
        label='Enable presentation mode'
        labelType='strong'
      />
      <div className='text-bedrock-p-small text-bedrock-black'>
        Allow recipients to navigate journey in presentation mode
      </div>
    </div>
  );
};
